var React = require('react');

function Spinner (props) {
    return React.createElement("svg",props,React.createElement("g",null,React.createElement("path",{"d":"M243.2,47.3C165.8,47.3,97.5,92,65.7,159.7l-22.1-45.9l-27.9,13.4l45.9,95.4l95.4-45.9l-13.4-27.9l-49.7,23.9\n\t\tc26.8-56.8,84.3-94.3,149.3-94.3c91.1,0,165.2,74.1,165.2,165.2s-74.1,165.2-165.2,165.2c-53.6,0-104.1-26.2-135.1-70.1l-25.3,17.9\n\t\tc36.8,52.1,96.7,83.2,160.4,83.2c108.2,0,196.2-88,196.2-196.2S351.3,47.3,243.2,47.3z"})));
}

Spinner.defaultProps = {"version":"1.1","id":"Capa_1","x":"0px","y":"0px","viewBox":"0 0 486.8 486.8","style":{"enableBackground":"new 0 0 486.8 486.8"},"xmlSpace":"preserve"};

module.exports = Spinner;

Spinner.default = Spinner;
